import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import App from '/components/App.vue';
import Faq from '/components/Faq.vue';
import Blog from '/components/Blog.vue';
import Favorites from '/components/Favorites.vue';


const staticRoutes = [
    { path: '/faq', component: Faq },
    { path: '/blog', component: Blog },
    { path: '/favorites', component: Favorites }
];

// Catch-all route to handle all dynamic paths
staticRoutes.push({
    path: '/:catchAll(.*)*',
    component: App
});

const router = createRouter({
    history: createWebHistory(),
    routes: staticRoutes
});

import BC from './init';

import './methods/testMethod';
import './methods/headerScroll';
import './methods/mobileMenu';
import './methods/introSlider';
import './methods/gridSlider';
import './methods/expanderControl';
import './methods/propertySlider';
import './methods/propertiesSimilarSlider';
import './methods/overflowCalculate';
import './methods/toggleContent';
import './methods/propertiesExpander';
import './methods/propertyItemSlider';
import './methods/loadDetails';
import './methods/addView';
import './methods/changeCurrency';


document.addEventListener('DOMContentLoaded', () => {
    const app = createApp(App);
    app.use(router);
    app.mount('#app');

    createApp(Faq).mount('#faq-app');
    createApp(Blog).mount('#blog-app');
    createApp(Favorites).mount('#favorites-app');

    BC.loadFunctions();
});